import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export class RenderPreview extends React.PureComponent {
    render() {
        const component = this.props.render(this.props);
        return component && _jsx("div", { style: this.props.style, children: component });
    }
}
//# sourceMappingURL=preview.js.map